import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { useCommonDataFindAllQuery, useSafetyFindAllQuery } from 'store';
import Detail from './Detail';
import safetySvg from '../../assets/images/svg/safety.svg'
import Create from './Create';


const SafetyIndex = (props: any) => {
  const [safetyTypeList, setSafetyTypeList] = useState<any>();
  const [safetyList, setSafetyList] = useState<any>();
  const [safetyOne, setSafetyOne] = useState<any>(null);
  const [isLoading, setLoading] = useState(true);
  const [isNewCreate, setIsNewCreate] = useState<boolean>(false);


  const {
    data: commonData,
    error: commonDataError,
    isFetching: isCommonDataFetching,
  } = useCommonDataFindAllQuery('?group_name=cmd_safety_type');

  const {
    data: safetyData,
    error: safetyDataError,
    isFetching: isSafetyDataFetching,
    refetch
  } = useSafetyFindAllQuery(`?table_name=${props?.table_name}&connection_id=${props?.id}`);

  useEffect(() => {

    setSafetyTypeList(commonData?.data)
    setSafetyList(safetyData?.data)
    setLoading(false)

  }, [commonData, props?.id, props?.table_name, safetyData, safetyList, safetyOne])


  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={safetySvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {safetyList?.length}
                  </span>
                </li>
              </ul>
            </div>
            <button
              type="button"
              disabled={isNewCreate}
              onClick={() => {setIsNewCreate(true)} }
              className="btn btn-success  btn-label"
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
            </button>
          </div>
        </Col>
        <Col lg={3}>

          <ul className="verti-timeline list-unstyled">
            {safetyList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.safeted_date}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setSafetyOne(item);
                            setIsNewCreate(false)
                          }}
                        >
                          {item?.company_description}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
          {
            isNewCreate === false ? 
            <Detail
            data={safetyOne}
            id={props?.id}
            table_name={props?.table_name}
            /> 
            : 
            <Create id={props?.id} table_name={props?.table_name}/>
          }
        
      </Row>
    </React.Fragment>
  );
}

export default SafetyIndex;